import {
	Integration,
	IntegrationProviderId,
	IntegrationStatus,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const dropboxIntegration = new Integration({
  id: "dropbox",
  name: "Dropbox integration",
  description:
    "Dropbox is a file hosting service that offers cloud storage, file synchronization, personal cloud, and client software.",
  providerId: IntegrationProviderId.DROPBOX,
  status: IntegrationStatus.INACTIVE,
  docsUrl: "",
	features: [],
  settingsConfig: [
		new SettingsConfig({
      id: "display_name",
      label: "Integration name",
      description:
        "The name of the integration that will be displayed in the integrations list",
      type: SettingsConfigType.STRING,
      required: true,
      editable: true,
      encrypted: false,
    }),
	],
});

export default dropboxIntegration;
